import { render, staticRenderFns } from "./DescPanel.vue?vue&type=template&id=81bd3290&scoped=true&"
import script from "./DescPanel.vue?vue&type=script&lang=js&"
export * from "./DescPanel.vue?vue&type=script&lang=js&"
import style0 from "./DescPanel.vue?vue&type=style&index=0&id=81bd3290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bd3290",
  null
  
)

export default component.exports